import { render, staticRenderFns } from "./PDPFilter.vue?vue&type=template&id=8bffec46&scoped=true&"
import script from "./PDPFilter.vue?vue&type=script&lang=js&"
export * from "./PDPFilter.vue?vue&type=script&lang=js&"
import style0 from "./PDPFilter.vue?vue&type=style&index=0&id=8bffec46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bffec46",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
